// https://app.json-generator.com/
import { Action, BatchResponse, BatchStorage } from '../../../models/batch';
import DateF from '../../../models/date-f';
import { Activity, Props as MenuFeedItemProps } from '../menu-feed-item';

const bulkDeleteAction = {
  type: "delete",
  description: 'Bulk delete'
} as Action;

const items = [
  {
    id: 'ac6bf2cc-134c-495e-8787-e82dfc86ee75',
    primaryText: 'Gould Fields',
    secondaryText: 'gould_fields@fossiel.amsterdam',
    caption: 'admin',
    isDisabled: false,
    isRestrictive: false
  },
  {
    id: 'f56f464f-82cb-48c4-9d70-d03d674b7e03',
    primaryText: 'Jeannette Sharpe',
    secondaryText: 'jeannette_sharpe@amtas.kddi',
    caption: 'member',
    isDisabled: false,
    isRestrictive: false
  },
  {
    id: '10f39e02-5417-46dd-b396-28545207a886',
    primaryText: 'Mercer Juarez',
    secondaryText: 'mercer_juarez@medmex.fish',
    caption: 'guest',
    isDisabled: false,
    isRestrictive: false
  },
  {
    id: '73005cd6-cdd2-4b2e-86a3-76aa8c22a7c9',
    primaryText: 'Roseann Calderon',
    secondaryText: 'roseann_calderon@multron.bar',
    caption: 'guest',
    isDisabled: false,
    isRestrictive: false
  },
  {
    id: '46fe5b51-b954-4e46-aa28-51f8bb0d1d39',
    primaryText: 'Lolita Lynch',
    secondaryText: 'lolita_lynch@mixers.swiss',
    caption: 'guest',
    isDisabled: false,
    isRestrictive: false
  },
  {
    id: '98dcf6c7-0462-4d5a-a159-81fa8c01d4ec',
    primaryText: 'Nielsen Gaines',
    secondaryText: 'nielsen_gaines@velity.contractors',
    caption: 'guest',
    isDisabled: false,
    isRestrictive: false
  },
  {
    id: '65cbe598-e3f9-4e36-9084-44e6bc7e29eb',
    primaryText: 'Margery Trevino',
    secondaryText: 'margery_trevino@kidgrease.photo',
    caption: 'member',
    isDisabled: false,
    isRestrictive: false
  },
  {
    id: '1d68c474-9382-469a-9d4b-ec92d144f01b',
    primaryText: 'Bridgett Stewart',
    secondaryText: 'bridgett_stewart@kinetica.services',
    caption: 'member',
    isDisabled: false,
    isRestrictive: false
  },
  {
    id: '6cd58363-9e54-4c21-a76c-100780684de9',
    primaryText: 'Virginia Finch',
    secondaryText: 'virginia_finch@qualitern.komatsu',
    caption: 'owner',
    isDisabled: false,
    isRestrictive: false
  },
  {
    id: '80f44229-fbb1-4472-90d8-75c52168a1dd',
    primaryText: 'Velma Mclean',
    secondaryText: 'velma_mclean@powernet.gmail',
    caption: 'owner',
    isDisabled: false,
    isRestrictive: false
  },
  {
    id: '06597788-f86f-4233-a506-3e63e4c683d4',
    primaryText: 'Kirsten Herring',
    secondaryText: 'kirsten_herring@deminimum.be',
    caption: 'guest',
    isDisabled: false,
    isRestrictive: false
  },
  {
    id: '04d96051-2a21-49ca-bba6-80eda38a3029',
    primaryText: 'Jewel Ramirez',
    secondaryText: 'jewel_ramirez@bittor.lc',
    caption: 'admin',
    isDisabled: false,
    isRestrictive: false
  },
  {
    id: 'd3122e8f-e391-4886-b023-0c9871eb1639',
    primaryText: 'Greta Stokes',
    secondaryText: 'greta_stokes@recritube.builders',
    caption: 'member',
    isDisabled: false,
    isRestrictive: false
  },
  {
    id: '8ccd6a78-dea9-470e-8a5a-204b5d64039c',
    primaryText: 'Burke Bond',
    secondaryText: 'burke_bond@klugger.jobs',
    caption: 'admin',
    isDisabled: false,
    isRestrictive: false
  },
  {
    id: 'e94505e6-080e-4dd8-883d-9a7760d9f318',
    primaryText: 'Chambers Ramos',
    secondaryText: 'chambers_ramos@letpro.mz',
    caption: 'owner',
    isDisabled: false,
    isRestrictive: false
  },
  {
    id: 'f6360e8c-025c-4c04-bb36-30eb02ac8548',
    primaryText: 'Perkins Marquez',
    secondaryText: 'perkins_marquez@knowlysis.an',
    caption: 'member',
    isDisabled: false,
    isRestrictive: false
  },
  {
    id: '128c537e-fb44-483a-b246-9d61108303fb',
    primaryText: 'Krista White',
    secondaryText: 'krista_white@gynk.tui',
    caption: 'owner',
    isDisabled: false,
    isRestrictive: false
  },
  {
    id: '133db357-18aa-4891-9b2f-e076d3ba37ee',
    primaryText: 'Mayo Kelly',
    secondaryText: 'mayo_kelly@qualitex.canon',
    caption: 'member',
    isDisabled: false,
    isRestrictive: false
  },
  {
    id: 'c1a8df46-b307-4397-a7ac-691d6b3d077b',
    primaryText: 'Bray Jimenez',
    secondaryText: 'bray_jimenez@namegen.chloe',
    caption: 'owner',
    isDisabled: false,
    isRestrictive: false
  },
  {
    id: 'c1142276-cba9-4f9a-ac91-3239df0cc3f4',
    primaryText: 'Nora Maxwell',
    secondaryText: 'nora_maxwell@geofarm.construction',
    caption: 'guest',
    isDisabled: false,
    isRestrictive: false
  },
  {
    id: 'c3c8375e-3339-4484-9559-19b14bea4f48',
    primaryText: 'Mccoy Lang',
    secondaryText: 'mccoy_lang@dadabase.ht',
    caption: 'admin',
    isDisabled: false,
    isRestrictive: false
  },
  {
    id: 'c74bb02e-2ddb-4838-924e-36299abb64f8',
    primaryText: 'Shannon Morton',
    secondaryText: 'shannon_morton@speedbolt.xin',
    caption: 'owner',
    isDisabled: false,
    isRestrictive: false
  },
  {
    id: 'a4fa7e5a-9424-41ff-b313-dd7ef0fee54f',
    primaryText: 'Sofia Castaneda',
    secondaryText: 'sofia_castaneda@austech.xerox',
    caption: 'admin',
    isDisabled: false,
    isRestrictive: false
  },
  {
    id: '84cdfd98-9b1c-465f-aef7-367eac75deb5',
    primaryText: 'Ann Ray',
    secondaryText: 'ann_ray@brainquil.cfa',
    caption: 'guest',
    isDisabled: false,
    isRestrictive: false
  },
  {
    id: 'c7ff90b5-1a73-4b92-bc71-15b6b2014af7',
    primaryText: 'Evans Howard',
    secondaryText: 'evans_howard@quilk.barclays',
    caption: 'admin',
    isDisabled: false,
    isRestrictive: false
  },
  {
    id: '0a8340e8-44db-4c19-9112-4864aa2563c2',
    primaryText: 'Myrna Craft',
    secondaryText: 'myrna_craft@veraq.cd',
    caption: 'admin',
    isDisabled: false,
    isRestrictive: false
  },
  {
    id: '172e68d8-252f-497d-840d-787e33c7da5e',
    primaryText: 'Lynne Mcgee',
    secondaryText: 'lynne_mcgee@zytrex.to',
    caption: 'guest',
    isDisabled: false,
    isRestrictive: false
  },
  {
    id: 'e837c137-834b-4636-92c7-20e5428af195',
    primaryText: 'Katie Lott',
    secondaryText: 'katie_lott@ovolo.pics',
    caption: 'owner',
    isDisabled: false,
    isRestrictive: false
  },
  {
    id: '2cc0ce0a-2571-46f3-9da6-d984f8c6ce52',
    primaryText: 'Arline Hudson',
    secondaryText: 'arline_hudson@polaria.erni',
    caption: 'admin',
    isDisabled: false,
    isRestrictive: false
  },
  {
    id: '7272080b-4bf9-48a3-b64a-630d697b9493',
    primaryText: 'Jennifer Lawrence',
    secondaryText: 'jennifer_lawrence@entropix.ifm',
    caption: 'member',
    isDisabled: false,
    isRestrictive: false
  },
];

export const groupItems = [
  {
    id: 'e00481e9-2909-4304-9d20-d9229daeb714',
    primaryText: 'Weightlifting Group',
    secondaryText: 'We lift things up and put them down',
    caption: '10 members',
    isDisabled: false,
    isRestrictive: false,
    members: [
      '7272080b-4bf9-48a3-b64a-630d697b9493',
      '172e68d8-252f-497d-840d-787e33c7da5e',
      'a4fa7e5a-9424-41ff-b313-dd7ef0fee54f',
    ],
  },
  {
    id: 'efe9e7a9-0946-4fe9-820d-b77a072fa5a7',
    primaryText: 'Construction Group',
    secondaryText: 'We build cool things',
    caption: '6 members',
    isDisabled: false,
    isRestrictive: false,
    members: [
      '10f39e02-5417-46dd-b396-28545207a886'
    ]
  },
];

export const roles = [
  {
    id: '',
    name: 'All Roles',
  },
  {
    id: 'admin',
    name: 'Admin',
    canManageRoles: false,
  },
  {
    id: 'owner',
    name: 'Owner',
    canManageRoles: true,
  },
  {
    id: 'guest',
    name: 'Guest',
    canManageRoles: false,
  },
  {
    id: 'member',
    name: 'Member',
    canManageRoles: false,
  },
];


export const fewItems = [
  {
    id: 'e837c137-834b-4636-92c7-20e5428af195',
    primaryText: 'Katie Lott',
    secondaryText: 'katie_lott@ovolo.pics',
    caption: 'owner',
  },
  {
    id: '2cc0ce0a-2571-46f3-9da6-d984f8c6ce52',
    primaryText: 'Arline Hudson',
    secondaryText: 'arline_hudson@polaria.erni',
    caption: 'admin',
  },
  {
    id: '7272080b-4bf9-48a3-b64a-630d697b9493',
    primaryText: 'Jennifer Lawrence',
    secondaryText: 'jennifer_lawrence@entropix.ifm',
    caption: 'member',
  },
];

export const memberships = [
  {
    id: "7272080b-4bf9-48a3-b64a-630d697b9999",
    user: "test user 1",
    email: "testuser@email.com",
    role_name: "Owner",
  },
  {
    id: "7272080b-4bf9-48a3-b64a-630d697b9998",
    user: "filtered",
    email: "testuser2@email.com",
    role_name: "Admin",
  }
]

export const apps = [
  {
    id: "7272080b-4bf9-48a3-b64a-630d697b9999",
    name: "My App",
    updated_at: Date.now(),
    record_count: 2,
  },
  {
    id: "7272080b-4bf9-48a3-b64a-630d697b9998",
    name: "Another App",
    updated_at: Date.now(),
    record_count: 3,
  }
]

export const CheckboxProps = {
  edge: 'start' as 'start',
  tabIndex: -1,
  disableRipple: true,
};

export const mockFeedItems: BatchStorage[] = [
  {
    url: 'some-record-url',
    activity: bulkDeleteAction,
    primaryText: 'Deleting 2,000 records',
    secondaryText: 'Some App Name',
    caption: 'Pending',
    status: 'pending',
    completedAt: undefined,
    isLastItem: false,
  },
  {
    url: 'another-record-url',
    activity: bulkDeleteAction,
    primaryText: '2,000 records deleted',
    secondaryText: 'Another App Name',
    caption: 'Completed 3 minutes ago in 4 minutes, 27 seconds',
    status: 'succeeded',
    isLastItem: true,
    completedAt: new DateF().DateTime.minus({ days: 2 }).toISO() as string,
  },
  {
    url: 'last-record-url',
    activity: bulkDeleteAction,
    primaryText: '2,000 records deleted',
    secondaryText: 'Last App Name',
    caption: 'Completed 5 minutes ago in 4 minutes, 27 seconds',
    status: 'succeeded',
    isLastItem: true,
    completedAt: new DateF().DateTime.minus({ hours: 2 }).toISO() as string,
  },
];

export const mockFailedFeedItems: BatchStorage[] = [
  {
    url: 'some-record-url',
    activity: bulkDeleteAction,
    primaryText: 'Deleting 2,000 records',
    secondaryText: 'Some App Name',
    caption: 'Error: Operation timed out',
    status: 'failed',
    isLastItem: false,
    startedAt: new DateF().DateTime.minus({ days: 3 }).toISO() as string,
  },
  {
    url: 'some-record-url',
    activity: bulkDeleteAction,
    primaryText: 'Deleting 1,500 records',
    secondaryText: 'Some App Name',
    caption: 'Error: Operation timed out',
    status: 'failed',
    isLastItem: true,
    startedAt: new DateF().DateTime.minus({ days: 7 }).toISO() as string,
  },
];

export const mockFailedInitialItems: MenuFeedItemProps[] = [
  {
    status: 'failed',
    activity: bulkDeleteAction,
    primaryText: 'Failed to delete records',
    secondaryText: 'There was a problem with the operation',
    caption: `Error: Operation timed out`,
    isLastItem: true,
  },
];

export const mockWhenRunningFeedItems: MenuFeedItemProps[] = [
  {
    url: 'some-record-url',
    activity: bulkDeleteAction,
    primaryText: 'Deleting 2,015 of 3,000 records',
    secondaryText: 'Some App Name',
    caption: 'Elapsed time 2m17s',
    status: 'running',
    isLastItem: true,
  },
];

export const completedResponse: BatchResponse = {
  status: 'succeeded',
  objects_total: 1000,
  objects_success: 1000,
  id: 'last-id',
  created_at: '2023-10-15T21:25:09.095Z',
  updated_at: '2023-10-15T21:25:09.095Z',
  created_by: 'last-user',
  created_by_id: 'last-user-id',
  updated_by: 'last-user',
  updated_by_id: 'last-user-id',
  started_at: '2023-10-15T21:25:35.095Z',
  completed_at: undefined,
  actions: [{
    type: 'delete',
    description: 'Delete records'
  }]
};

export const mockBatchResponse: BatchResponse[] = [
  {
    status: 'running',
    objects_total: 1000,
    objects_success: 430,
    id: 'some-id',
    created_at: '2023-09-27T21:25:09.095Z',
    updated_at: '2023-09-27T21:25:09.095Z',
    created_by: 'some-user',
    created_by_id: 'some-user-id',
    updated_by: 'some-user',
    updated_by_id: 'some-user-id',
    started_at: '2023-10-15T21:25:35.095Z',
    completed_at: undefined,
    actions: [{
      type: 'delete',
      description: 'Delete records'
    }]
  },
  {
    status: 'failed',
    objects_total: 1000,
    objects_success: 430,
    id: 'another-id',
    created_at: '2023-09-25T21:25:09.095Z',
    updated_at: '2023-09-25T21:25:09.095Z',
    created_by: 'another-user',
    created_by_id: 'another-user-id',
    updated_by: 'another-user',
    updated_by_id: 'another-user-id',
    started_at: '2023-10-15T21:25:35.095Z',
    completed_at: undefined,
    actions: [{
      type: 'delete',
      description: 'Delete records'
    }]
  },
];

export default items